/**
 * QuotaCtas — upgrade ProductUpgrade buttons + view_plans.
 * Mirrors Rails shared/_quota_ctas.html.erb.
 */

import { h } from 'preact'
import { quotaUpgradePath } from './parseQuotaError.js'
import { t as defaultT } from './quota-i18n.js'

export function QuotaCtas({
  upgrades = [],
  t = defaultT,
  variant = 'danger',
  size = 'sm',
  className = ''
}) {
  const sizeClass = size ? ` btn-${size}` : ''
  const outline = `btn btn-outline-${variant}${sizeClass}`
  const plansPath = upgrades[0]?.path ?? quotaUpgradePath(null)

  return (
    <div class={`d-flex flex-wrap align-items-center gap-2 ${className}`.trim()}>
      {upgrades.map((upgrade) => {
        const label =
          upgrade.amountHuf != null
            ? `${upgrade.label} ${t('quotas.price_huf', { amount: upgrade.amountHuf.toLocaleString() })}`
            : upgrade.label
        return (
          <a
            key={upgrade.productCode ?? upgrade.label}
            href={upgrade.path}
            class={outline}
          >
            {label}
          </a>
        )
      })}
      <a href={plansPath} class={outline}>
        {t('quotas.view_plans')}
      </a>
    </div>
  )
}

export default QuotaCtas
